import React, { useCallback } from 'react'
import { intl } from 'lang/intl'
import { TtButton, TtIcon, TtTooltip } from '@23/react'
import {
  toggleLiveTranscriptions,
  useAreLiveTranscriptionsEnabled,
} from '../hooks/useLiveTranscriptionsOverlay'

export const LiveTranscriptionsToggle = () => {
  const isTranscriptionEnabled = useAreLiveTranscriptionsEnabled()

  const onClickHandler = useCallback(async () => {
    toggleLiveTranscriptions()
  }, [])

  const buttonColor: HTMLTtButtonElement['color'] = isTranscriptionEnabled
    ? 'primary'
    : 'secondary'

  const message = isTranscriptionEnabled
    ? intl.formatMessage({
        defaultMessage: 'Hide Live Transcriptions',
      })
    : intl.formatMessage({
        defaultMessage: 'Show Live Transcriptions',
      })

  return (
    <TtTooltip content={message} placement="left" distance={16}>
      <TtButton circle color={buttonColor} onClick={onClickHandler}>
        <TtIcon name="subtitles" library="one/global" />
      </TtButton>
    </TtTooltip>
  )
}
